import React from 'react';
import styled from 'styled-components';

import ResponsiveTable from './responsive-table';

type Props = {
  children: React.ReactNode;
};

const Pre = styled.pre`
  background-color: var(--pre-bg);
  border-radius: var(--grvsc-border-radius, 8px);
  color: var(--pre-text);
  padding-top: var(--grvsc-padding-top, var(--grvsc-padding-v, 1rem));
  padding-bottom: var(--grvsc-padding-bottom, var(--grvsc-padding-v, 1rem));
  padding-left: var(--grvsc-padding-left, var(--grvsc-padding-h, 1.5rem));
  padding-right: var(--grvsc-padding-right, var(--grvsc-padding-h, 1.5rem));
  max-height: 200px;
  overflow-y: scroll;
`;

const CSV: React.FC<Props> = ({ children }) => {
  const csvRawStr: string = children[0];
  const csvArr = csvRawStr.split('\n');
  csvArr.splice(0, 1);
  csvArr.pop();

  const buildJson = (csvArr: string[]): string => {
    const obj = {
      thead: [],
      tbody: [],
    };

    for (let i = 0; i < csvArr.length; ++i) {
      let part = '';
      if (i === 0) {
        part = 'thead';
      } else {
        part = 'tbody';
      }
      obj[part].push(csvArr[i].split(','));
    }

    return JSON.stringify(obj);
  };

  return (
    <>
      <Pre data-language="csv">
        <code>{csvArr.join('\n')}</code>
      </Pre>
      <ResponsiveTable size="sm" maxHeight={200}>
        {buildJson(csvArr)}
      </ResponsiveTable>
    </>
  );
};

export default CSV;
